export default __webpack_public_path__ + "static/media/google-play-navy.299c9201.svg";